import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { I18NextModule } from 'angular-i18next';
import { IconComponent } from 'src/app/common/icon/icon.component';
import { NotLoggedService } from 'src/app/common/not-logged/not-logged.service';
import { ReportableEntityEnum } from 'src/types/graphql';
import { ReportService } from './report.service';

@Component({
  selector: 'sharry-report',
  standalone: true,
  imports: [
    MatDialogModule,
    I18NextModule,
    MatButtonModule,
    MatRadioModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    IconComponent,
  ],
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportComponent {
  @Input() data: { reportedEntityId: any; reportedEntityType: ReportableEntityEnum };
  @Input() isCreate = false;
  @Input() isSharryManagement = false;
  @Input() isPlaceUtility = false;
  @Input() isTitle = true;
  @Input() disabled = false;
  @Input() title: string;
  @Input() icon = 'flag';
  @Input() iconType: 'phosphor' | 'custom' = 'phosphor';

  constructor(
    private reportService: ReportService,
    private notLoggedService: NotLoggedService,
  ) {}

  onReport() {
    if (!this.disabled) {
      const fun = () => {
        this.reportService.openDialog({
          ...this.data,
          isCreate: this.isCreate,
          isPlaceUtility: this.isPlaceUtility,
          isSharryManagement: this.isSharryManagement,
        });
      };
      this.notLoggedService.execute(() => fun());
    }
  }
}
